module.exports = __webpack_public_path__ + "pc/img/logo.6cc8c0f1.png";